import { MapaEnviromentService, Wso2IntegrationService } from '@mapa/core';
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { TranslateService } from '@ngx-translate/core';
import { AppMessageService } from '../core/message/app-message.service';
import { SegurancaService } from './seguranca.service';

@Injectable({
    providedIn: 'root'
})

export class AutoLogoutService{

    private timeoutMessage: string;
    private navigateToRoute: string;

    private broadcastChannel: BroadcastChannel;
    private closing = false;
    private doLogoutOnClose = true;
    private timeoutInMinute: number;

    constructor(private router: Router,
                private wso2IntegrationService: Wso2IntegrationService,
                private segurancaService: SegurancaService,
                private idle: Idle,
                private appMessageService: AppMessageService,
                private translate: TranslateService){
        MapaEnviromentService.get((config: any) => {
            if(config.timeoutSessaoMinutos){
                this.timeoutInMinute = config.timeoutSessaoMinutos * 60;
            }
        });
    }

    public startService(navigateToRoute: string = '/', timeoutMessage: string = 'CORE.AUTH.SESSION_TIMEOUT_MESSAGE'){
        this.timeoutMessage = timeoutMessage;
        this.navigateToRoute = navigateToRoute;
        this.startIdleMonitor();
        this.broadcastChannel = new BroadcastChannel("sgsia");
        this.broadcastChannel.addEventListener("message", (event) => {
            console.log('message', event.data);
            if(event.data === 'doLogOut'){
                this.broadcastChannel.postMessage(false);
            }
            if(!event.data && this.closing){
                this.doLogoutOnClose = false;
            }
          });
        window.addEventListener('unload',()=>{
            this.closing = true;
            this.broadcastChannel.postMessage('doLogOut');
            setTimeout(() => {
                if(this.doLogoutOnClose){
                    this.wso2IntegrationService.logout();
                }
            }, 4);
        });
    }


    private startIdleMonitor(){
        if(!this.timeoutInMinute || this.timeoutInMinute < 1){
            return;
        }

        this.idle.setIdle(5);
        this.idle.setTimeout(this.timeoutInMinute);
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onTimeout.subscribe(()=>{
            this.idle.stop();
            if(this.segurancaService.isAnalistaFiscal() || this.segurancaService.isEstabelecimento() || this.segurancaService.isGestor()){
                this.translate.get(this.timeoutMessage).subscribe(  (texto: string) => {
                    this.appMessageService.addConfirmOk(texto,() => {
                        this.router.navigate([this.navigateToRoute])
                            .then(()=>{
                                this.wso2IntegrationService.logout();
                                window.location.reload();
                            }).catch(reason => console.log(reason));
                    });

                });
            }
        });

        this.idle.watch();
    }


}
